import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		headerContainer: {
			height: 60,
			borderBottom: `1px solid ${theme.palette.grey[200]}`,
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			position: 'absolute',
			top: 0,
			width: '100%',
		},
		contentStoryRoot: {
			width: '100%',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			alignSelf: 'stretch',
			position: 'absolute',
			paddingTop: '10px',
			flexGrow: 1,
			height: '100%',
			overflowY: 'auto',
			[theme.breakpoints.down('sm')]: {
				padding: `0px ${theme.spacing(1)}px`,
			},
		},
		titleSection: {
			width: '100%',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			borderBottom: `1px solid ${theme.palette.grey[200]}`,
		},
		imageBtn: {
			width: 'auto',
			padding: '5px 30px',
			background: `${theme.palette.grey[200]}`,
			borderRadius: '20px',
			display: 'flex',
			alignItems: 'center',
			flexFlow: 'row',
			fontSize: 14,
			fontWeight: 700,
		},
		storyTitle: {
			marginTop: theme.spacing(2),
			marginBottom: theme.spacing(2),
			width: '100%',
			'& input': {
				textAlign: 'center',
				padding: theme.spacing(1),
				color: theme.palette.grey[800],
				fontSize: 16,
				fontWeight: 500,
				borderBottom: 'none',
				'&:before': {
					display: 'none',
				},
			},
		},
		closeButton: {
			width: 24,
			height: 24,
			padding: 0,
			paddingLeft: theme.spacing(1),
		},
		leftMenu: {
			alignSelf: 'stretch',
			flexDirection: 'row',
			alignItems: 'center',
			display: 'flex',
		},
		middleMenu: {
			flex: 1,
			alignSelf: 'stretch',
			flexDirection: 'row',
			alignItems: 'center',
			display: 'flex',
			justifyContent: 'center',
			[theme.breakpoints.down('sm')]: {
				justifyContent: 'space-around',
			},
		},
		rightMenu: {
			alignSelf: 'stretch',
			flexDirection: 'row',
			alignItems: 'center',
			display: 'flex',
			justifyContent: 'flex-end',
		},
		container: {
			marginTop: theme.spacing(2),
			flexGrow: 1,
		},
		activeContainer: {
			position: 'relative',
			// margin: '0 -15px',
			margin: `${theme.spacing(1)}px 0 0 0`,
			padding: 0,
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-start',
			justifyContent: 'space-between',
			flex: 1,
			alignSelf: 'stretch',
			cursor: 'pointer',
			'& .fr-box': {
				display: 'flex',
				flexDirection: 'column',
				alignSelf: 'stretch',
				// height: '100%',
				flexGrow: 1,
				'& .fr-element': {
					paddingTop: 0,
					paddingLeft: 8,
				},
				'& .fr-placeholder': {
					// paddingTop: '1em!important',
					// paddingBottom: '1em!important',
				},
				'& > .fr-toolbar': {
					border: 'none',
					boxShadow: 'none',
					background: 'transparent',
				},
				'& > .fr-wrapper': {
					flexGrow: 1,
					boxShadow: 'none!important',
					background: 'transparent',
				},
			},
			[theme.breakpoints.down('sm')]: {
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				background: '#ffffff',
				zIndex: 100,
			},
		},
		buttonsContainer: {
			flex: 1,
			alignSelf: 'stretch',
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'space-between',
			maxHeight: 48,
			'& > button': {
				flex: 1,
				height: theme.spacing(6),
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				justifyContent: 'center',
				color: '#ffffff',
				fontSize: 18,
			},
		},
		cancelButton: {
			fontWeight: 500,
			backgroundColor: theme.palette.grey[300],
		},
		saveButton: {
			fontWeight: 700,
			backgroundColor: theme.palette.secondary.main,
		},
		preview: {
			padding: 16,
			overflow: 'auto',
			[theme.breakpoints.down('sm')]: {
				padding: 8,
			},
		},
		error: {
			'& .fr-placeholder': {
				color: 'rgba(255,0,0,0.5)!important',
			},
			'& $preview': {
				color: 'rgba(255,0,0,0.5)!important',
			},
		},
		editorContainer: {
			border: `1px solid ${theme.palette.grey[200]}`,
		},

		iconRoot: {
			marginRight: theme.spacing(8),
		},
		featuredMediaContainer: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-around',
			minHeight: 'fit-content',
			position: 'relative',
			border: `1px solid ${theme.palette.grey[200]}`,
			borderRadius: theme.spacing(1),
			overflow: 'hidden',
			marginTop: theme.spacing(1),
		},
		deleteIconLabel: {
			paddingLeft: 6,
			paddingRight: 6,
		},
		deleteRootElement: {
			position: 'absolute',
			top: 0,
			right: 0,
		},
		player: {
			'& iframe': {
				width: '100%',
				height: '100%',
			},
		},
		textError: {
			'& input::-webkit-input-placeholder': {
				/* Chrome/Opera/Safari */
				color: '#FC2652 !important',
				fontWeight: 'bold',
				opacity: '1',
			},
			'& input::-moz-placeholder': {
				/* Firefox 19+ */

				color: '#FC2652 !important',
				fontWeight: 'bold',
				opacity: '1',
			},
			'& input:-moz-placeholder': {
				/* Firefox 18- */
				color: '#FC2652 !important',
				fontWeight: 'bold',
				opacity: '1',
			},
			'& input:-ms-input-placeholder': {
				/* IE 10+ */
				color: '#FC2652 !important',
				fontWeight: 'bold',
				opacity: '1',
			},
		},
		requiredText: {
			alignSelf: 'baseline',
			color: theme.palette.secondary.main,
			fontWeight: 'bold',
		},
	})
